import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../../StateContext/Application'
import { Form, Link, useParams } from 'react-router-dom'
import apiurl from '../../../../../path'

const WinnerDeclartionForm = () => {
  const { id } = useParams()
  const data = useContext(AdminContext)
  const { GetWinnerDeclare, MakeWinner, ReverseWinner,CreateToken } = data
  const [renderdata, SetRenderdata] = useState([])
  const [WinnerData, SetWinnerData] = useState([])
  const [searchdata, SetSearchData] = useState([])
  const [hide, sethide] = useState(true)
  const [Message, setMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = renderdata.slice(indexOfFirstItem, indexOfLastItem);
  var csv = [
    ["AC_NO", "Beneficiary_Name", "Amount", "Beneficiary_AC_NO", "Beneficiary_IFSC", "Branch", "Bank", "Adhar_no", "Benefit_Application_ID"]
  ]
  const addlist = (target, Account_Number, Beneficiary_Name, Payment, Confirm_Account_Number, IFSC_Code, Branch_Name, Bank_Name, Aadhar_Number, Aadhar_Number1) => {
    try {
      if (target.checked) {
        csv.push([Account_Number, Beneficiary_Name, Payment, Confirm_Account_Number, IFSC_Code, Branch_Name, Bank_Name, Aadhar_Number, Aadhar_Number1]);
      } else {
        csv.forEach((e) => {
          if (e[0] == Account_Number) {
            console.log('Removed')
            csv.splice(csv.indexOf(e), 1);
          }
        });
      }
    } catch (error) {
      console.error('Error handling checkbox:', error);
    }
  };

  useEffect(() => {
    async function getlist() {
      try {
        let d = await GetWinnerDeclare(id)
        SetSearchData(d)
        SetRenderdata(d)
      } catch (error) {
        console.error('Error fetching winner data:', error);
      }
    }
    getlist()
  }, [])
  var upload = new FormData();

  const SelectAll = (e) => {
    try {
      const checkboxes = document.querySelectorAll('input');
      if (checkboxes[1].checked == true) {
        csv = [
          ["AC_NO", "Beneficiary_Name", "Amount", "Beneficiary_AC_NO", "Beneficiary_IFSC", "Branch", "Bank", "Adhar_no", "Benefit_Application_ID"]
        ]
        checkboxes.forEach((element) => {
          if (element.type === 'checkbox') {
            element.checked = true;
          }
        });

        renderdata.forEach((e) => {
          csv.push([e.Account_Number, e.Beneficiary_Name, e.Payment, e.Confirm_Account_Number, e.IFSC_Code, e.Branch_Name, e.Bank_Name, e.Aadhar_Number, e.Aadhar_Number])
        })

        const textToSave = csv.map((item) => Object.values(item).join('|')).join('\n');
        const blob = new Blob([textToSave], { type: 'text/plain;charset=utf-8' });
        return
      }
      else if (checkboxes[1].checked == false) {
        console.log('hey')
        csv = [
          ["AC_NO", "Beneficiary_Name", "Amount", "Beneficiary_AC_NO", "Beneficiary_IFSC", "Branch", "Bank", "Adhar_no", "Benefit_Application_ID"]
        ]
        checkboxes.forEach((element) => {
          if (element.type === 'checkbox') {
            element.checked = false;
          }
        });
      }
    } catch (error) {
      console.error('Error handling select all:', error);
    }

  }

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const upload = new FormData();
      const image = document.getElementById('document').files
      let file = image[0];
      upload.append('WinnerDocument', file)
      upload.append('message', Message)
      Object.keys(WinnerData).forEach((key) => {
        upload.append(key, WinnerData[key])
      })
      let b = await MakeWinner(upload)
      if (b === true) {
        alert('winner Declared')
        window.location.reload()
      }
      else {
        alert('failed')
      }
    } catch (error) {
      console.error('Error handling submit:', error);
    }
  };

  const ReverseWinnerDeclare = async (e) => {
    try {
      e.preventDefault();
      let b = await ReverseWinner(WinnerData)
      if (b === true) {
        alert('winner Removed')
        window.location.reload()
      }
      else {
        alert('failed')
      }
    } catch (error) {
      console.error('Error handling reverse winner:', error);
    }
  }

  const search = (e) => {
    try {
      let searchValue = e.target.value.toLowerCase();

      if (!searchValue) {
        SetRenderdata(searchdata); // If search value is empty, show all data
        return;
      }

      let newdata = searchdata.filter((item) => {
        // Check for a match in multiple fields
        return (
          item.Bidder_CompanyName.toLowerCase().includes(searchValue) ||
          item.GST_No.toLowerCase().includes(searchValue) ||
          item.PAN_No.toLowerCase().includes(searchValue) ||
          item.City.toLowerCase().includes(searchValue)
        );
      });

      SetRenderdata(newdata);
    } catch (error) {
      console.error('Error handling search:', error);
    }
  }

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  return (
    <div style={{ justifyContent: 'center', display: 'grid', backgroundColor: "#f6f8fc", padding: "50px" }} >
      <div style={{ display: "grid", border: "2px solid red", borderRadius: "20px", border: "none", padding: "20px", backgroundColor: 'white' }}>
        <div className='my-1 mx-3'>
          <h5><b>Tender Winner Declartion Form </b></h5>
        </div>

        <div className='my-1 mx-3'>
          <span style={{ display: "flex", justifyContent: "center" }}>
            <input className='form-control' type='search' placeholder='Search Tenders by bidder_companyName & pan no or Gst no ' onChange={(e) => { search(e) }} />
          </span>
        </div>
      </div>
      <div style={{ overflow: 'auto' }}>


        <table className="table table-striped" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                <div>checkall</div>
                <input type='checkbox' className='checkbox' onClick={() => SelectAll('j')} />
              </th>
              <th style={{ whiteSpace: 'nowrap' }}>Declare Winner</th>
              <th>Tender_Name</th>
              <th>Bidder Name</th>
              <th>City</th>
              <th>GST No</th>
              <th>PAN No</th>
              <th>Mobile_No</th>
              <th>Email</th>
              <th>Payment Amount</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((e, index) => (
              <tr className="" key={index}>
                <td style={{ textAlign: 'center' }}>
                  <input type='checkbox' className="checkbox" onClick={(x) => addlist(x.target, e.Account_Number, e.Beneficiary_Name, e.Payment, e.Confirm_Account_Number, e.IFSC_Code, e.Branch_Name, e.Bank_Name, e.Aadhar_Number, e.Aadhar_Number)} />
                </td>
                {e.WinningStatus === 'Tender Winner' && e.Refund_Status === "No Refund" ? (
                  <td>
                    <button className='btn btn-danger' onClickCapture={() => SetWinnerData(e)} onClick={(x) => { SetWinnerData(e); ReverseWinnerDeclare(x) }} style={{ border: "none", borderRadius: "10px" }}>Reverse Winner</button>
                  </td>
                ) : (
                  <td>
                    <button className='spclbtn hovereffect' onClickCapture={() => SetWinnerData(e)} onClick={(x) => { SetWinnerData(e); sethide(false) }}>Declare Winner</button>
                  </td>
                )}
                <td>{e.Tender_Name}</td>
                <td>
                  <i className="fa fa-building mx-1" aria-hidden="true"></i>
                  {e.Bidder_CompanyName}
                </td>
                <td>{e.City}</td>
                <td>{e.GST_No}</td>
                <td>{e.PAN_No}</td>
                <td>{e.Mobile_No}</td>
                <td>{e.Email}</td>
                <td style={{ color: 'red' }} onMouseEnter={(e) => { e.currentTarget.childNodes[0].hidden = false }} onMouseLeave={(e) => { e.currentTarget.childNodes[0].hidden = true }}>
                  <textarea hidden={true} contentEditable='false' className='form-control' value={e.PaymentAmount + '+' + e.TenderFee + '+' + e.ErnestMoneyDeposit + '+' + e.GstAmount} ></textarea>
                  <b>{e.PaymentAmount}</b>

                </td>

              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ul className="pagination">
            {Array(Math.ceil(renderdata.length / itemsPerPage))
              .fill()
              .map((_, index) => (
                <li key={index} className="page-item">
                  <button onClick={() => paginate(index + 1)} className="page-link">
                    {index + 1}
                  </button>
                </li>
              ))}
          </ul>
        </div>
            {/* This is the Token Form */}

        <div class="card" style={{ width: '100%',height:"100%",position:'absolute',top:'0',left:'0'}} hidden={hide}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h6>Send Message</h6>
              <button className="btn btn-close mb-3 mx-3" aria-label="close" style={{ padding: "10px", backgroundColor: "#f6f8fc", border: "2px", width: "1rem", height: "1rem", borderRadius: "20px" }} onClick={(x) => sethide(true)}></button>
            </div>
          <h5 style={{ textAlign: "center" }}>{WinnerData.Bidder_CompanyName}</h5>
          <div class="card-body">  
            <textarea id='message' className='form-control my-3' onChange={(e) => { setMessage(e.target.value) }}></textarea>
            <input type="file" className="form-control my-2" id='document'></input>
            <hr></hr>
            <button className='btn btn-success mx-2' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none", borderRadius: "10px" }} onClick={(x) => handleSubmit(x)}>Submit</button>
            <button className='btn btn-danger' style={{ backgroundColor: "#e73d26", border: "none", borderRadius: "10px" }} onClick={(x) => sethide(true)}>close</button>
          </div>

        </div>

        <button className='btn btn-success my-3' style={{ backgroundColor: "rgb(10, 200, 150)", border: "none" }}>Check file</button>
      </div>

    </div>
  )
}

export default WinnerDeclartionForm